export const systemUserIdStart = 10000;
export const systemBusinessIdStart = 100;
export const STRIPE_PUBLIC_KEY = "pk_test_51HKU4ADOMol0pQALCZcIDCiyAY1mo6nPyGlAQhAB1l694YQk4Z7nJWWzmI4JAECkVNS6dI6TMryz2zNTMjUq11Ft00Do7LglMA"